import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  Stack,
} from '@chakra-ui/react';
import { useRef } from 'react';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  message?: string;
  btnCancel?: string;
  btnDelete?: string;
  handleConfirm?: () => void;
  isDeleting?: boolean;
};

export const AlertModal = ({
  title,
  message,
  btnCancel,
  btnDelete,
  handleConfirm,
  isDeleting,
  isOpen,
  onClose,
}: Props) => {
  const cancelRef = useRef(null);

  return (
    <AlertDialog leastDestructiveRef={cancelRef} isOpen={isOpen} onClose={onClose}>
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader fontSize="lg" fontWeight="bold">
            {title}
          </AlertDialogHeader>
          <AlertDialogBody>{message}</AlertDialogBody>
          <AlertDialogFooter>
            <Stack direction="row">
              <Button ref={cancelRef} onClick={onClose}>
                {btnCancel}
              </Button>
              <Button colorScheme="red" isLoading={isDeleting} onClick={handleConfirm}>
                {btnDelete}
              </Button>
            </Stack>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
};
